import Vue from 'vue'
import Router from 'vue-router'

import Home from './components/Home.vue'


Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      nav: true,
      navTitle: 'Home'
    },
    {
      path: '/prizes',
      name: 'prizes',
      component: () => import(/* webpackChunkName: "late" */ './views/Prizes.vue'),
      nav: true,
      navTitle: 'Prizes'
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import(/* webpackChunkName: "late" */ './views/Faq.vue'),
      nav: true,
      navTitle: 'FAQS'
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import(/* webpackChunkName: "late" */ './views/Terms.vue'),
      nav: true,
      navTitle: 'T&CS'
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import(/* webpackChunkName: "late" */ './views/Privacy.vue'),
      nav: true,
      navTitle: 'Privacy Notice'
    },
    {
      path: '/soon',
      name: 'soon',
      component: () => import(/* webpackChunkName: "soon" */ './views/tooSoon.vue'),
      nav: false,
      navTitle: 'Too Soon'
    },
    {
      path: '/late',
      name: 'late',
      component: () => import(/* webpackChunkName: "late" */ './views/tooLate.vue'),
      nav: false,
      navTitle: 'Too Late'
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "late" */ './forms/Contact.vue'),
      nav: false,
      navTitle: false
    },
    {
      path: '/book/:id',
      name: 'book',
      component: () => import(/* webpackChunkName: "late" */ './views/Prizes.vue'),
      nav: false,
      navTitle: 'Book',
      props: true
    },
    {
      path: '/friend/:id',
      name: 'friend',
      component: () => import(/* webpackChunkName: "late" */ './views/Prizes.vue'),
      nav: false,
      navTitle: 'Friend',
      props: true
    },
    {
      path: '/win',
      name: 'win',
      component: () => import(/* webpackChunkName: "late" */ './views/Win.vue'),
      nav: false,
      navTitle: 'Win',
      props: true
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: () => import(/* webpackChunkName: "late" */ './views/Thanks.vue'),
      nav: false,
      navTitle: 'Thanks'
    },
    {
      path: '/wait',
      name: 'timeout',
      component: () => import(/* webpackChunkName: "late" */ './views/Timeout.vue'),
      nav: false,
      navTitle: 'Timeout'
    },
    {
      path: '/sorry',
      name: 'sorry',
      component: () => import(/* webpackChunkName: "late" */ './views/Sorry.vue'),
      nav: false,
      navTitle: 'Sorry'
    },
    {
      path: '*',
      name: 'notfound',
      component: () => import(/* webpackChunkName: "late" */ './views/NotFound.vue'),
      nav: false,
      navTitle: '404 - Page Not Found'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // let terms, faq and privacy through
  if(['terms','privacy','faq'].indexOf(to.name)!== -1) {
    return next();
  }else{
    return next();
  }
  /*if(siteStatus.status == ''){
    // No site status set
    return axios.get('/api/getSiteStatus').then((res) => {
      console.log(res);
      if(res.data){
        if (res.data.success) {
          siteStatus.status = res.data.payload.stateCode;
        }
      }
    });
  }
  console.log(siteStatus);
  return next();*/
})

export default router;